import Highcharts from "highcharts";

// Global chart safety: disable Highcharts' hideOverlappingLabels pass for data
// labels. That pass crashes ("Cannot read properties of undefined (reading
// 'labelrank')") when a chart has hidden series or null points — which our
// conditional/filtered charts commonly do. allowOverlap skips it entirely.
if (Highcharts && Highcharts.setOptions) {
    Highcharts.setOptions({
        plotOptions: {
            series: { dataLabels: { allowOverlap: true } },
        },
    });
}

// Shared, styled per-point tooltip for all profile charts.
const esc = (s) =>
    String(s == null ? "" : s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export function pointTooltip(opts = {}) {
    const { unit = "", unitBySeries = null, valueLabel = "", maxValue = null, decimals = null } = opts;
    return {
        enabled: true,
        shared: false,
        useHTML: true,
        backgroundColor: "#ffffff",
        borderColor: "#e2e8f0",
        borderRadius: 10,
        borderWidth: 1,
        shadow: true,
        padding: 0,
        style: { fontFamily: "'Outfit', 'Segoe UI', sans-serif" },
        formatter: function () {
            const color = this.point && this.point.color ? this.point.color : this.series.color;
            const name = esc(this.series.name);
            const label = this.key != null ? esc(this.key) : "";
            let v = this.y;
            if (decimals != null && v != null) v = Number(v).toFixed(decimals);
            const u = unitBySeries && unitBySeries[this.series.name] != null ? unitBySeries[this.series.name] : unit;
            const valStr = maxValue != null
                ? `${v}<span style="color:#94a3b8;font-weight:600"> / ${maxValue}${u}</span>`
                : `${v}${u}`;
            return (
                `<div style="min-width:120px;padding:8px 12px">` +
                (label ? `<div style="font-size:11px;color:#94a3b8;margin-bottom:3px">${label}</div>` : "") +
                `<div style="display:flex;align-items:center;gap:7px">` +
                `<span style="width:9px;height:9px;border-radius:50%;background:${color};display:inline-block"></span>` +
                `<span style="font-size:12.5px;font-weight:700;color:#334155">${name}</span>` +
                `</div>` +
                `<div style="margin-top:3px;font-size:15px;font-weight:700;color:${color}">` +
                (valueLabel ? `<span style="font-size:11px;color:#94a3b8;font-weight:600">${esc(valueLabel)}: </span>` : "") +
                valStr +
                `</div>` +
                `</div>`
            );
        },
    };
}
